/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Cover_UpdatedInputs */

const cs_blog_cover_updated = /** @type {(inputs: Blog_Cover_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úvodní obrázek aktualizován`)
};

const en_blog_cover_updated = /** @type {(inputs: Blog_Cover_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover image updated`)
};

/**
* | output |
* | --- |
* | "Cover image updated" |
*
* @param {Blog_Cover_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_cover_updated = /** @type {((inputs?: Blog_Cover_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Cover_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_cover_updated(inputs)
	return cs_blog_cover_updated(inputs)
});